import { useState } from "react";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function ProjectDetails({ project, expanded = false }) {
  const [isExpanded, setIsExpanded] = useState(expanded);

  // If expanded prop is true, show all fields without toggle
  if (expanded) {
    return (
      <div className="space-y-3 text-sm">
        <Field label="Category" value={project.category} />
        <Field label="Description" value={project.description} />
        <Field label="Strategy" value={project.brand_strategy} />
        <Field label="Attributes" value={project.attributes?.join(", ")} />
        <Field label="Differentiators" value={project.differentiators?.join(", ")} />
        <Field label="Countries" value={project.countries?.join(", ")} />
        <Field label="Nice Classes" value={project.nice_classes?.join(", ")} />
        <Field label="Max Characters" value={project.max_chars} />
      </div>
    );
  }

  return (
    <div>
      {/* Toggle */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center gap-2 text-xs text-base-content/50 hover:text-base-content/70 transition-colors w-full"
      >
        <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} className="text-[10px]" />
        <span>Brief</span>
      </button>

      {/* Collapsible content */}
      {isExpanded && (
        <div className="mt-3 space-y-3 text-sm">
          <Field label="Category" value={project.category} />
          <Field label="Description" value={project.description} />
          <Field label="Strategy" value={project.brand_strategy} />
          <Field label="Attributes" value={project.attributes?.join(", ")} />
          <Field label="Differentiators" value={project.differentiators?.join(", ")} />
          <Field label="Countries" value={project.countries?.join(", ")} />
          <Field label="Nice Classes" value={project.nice_classes?.join(", ")} />
          <Field label="Max Characters" value={project.max_chars} />
        </div>
      )}
    </div>
  );
}

const Field = ({ label, value }) => {
  if (!value) return null;
  return (
    <div>
      <span className="text-xs text-base-content/40 block">{label}</span>
      <span className="text-base-content/70">{value}</span>
    </div>
  );
};

export default ProjectDetails;
